import  {  createContext } from 'react';
 
export const ChannelSideBarContext = createContext({} as any);